module.exports = __webpack_public_path__ + "img/activity8.ed8511c0.png";